import React from 'react'
import { Box } from '@mui/material'
import { gridClasses } from '../styles'

const Separator: React.FC = () => {
  return <Box sx={gridClasses.avatarBarSeparator} />
}

export default Separator
